import { CiapSelectFieldModel } from 'components/form/field/select/CiapSelectField/CiapSelectField'
import { CidSelectFieldModel } from 'components/form/field/select/CidSelectField/CidSelectField'
import { Calculation } from 'final-form-calculate'
import { emptyArrayOf } from 'util/array'
import { metaPath } from 'util/metaPath'

import { HistoricoAtendimentoAdvancedFilterFormModel } from '../../model/model-historico'

const metaFiltroHistorico = metaPath<HistoricoAtendimentoAdvancedFilterFormModel>()

export function createFiltroHistoricoCalculation(): Calculation {
  return {
    field: [metaFiltroHistorico.exibirRegistrosInativos.absolutePath()],
    updates: {
      [metaFiltroHistorico.ciaps2.absolutePath()]: (
        exibirRegistrosInativos: boolean,
        allValues: HistoricoAtendimentoAdvancedFilterFormModel
      ) => {
        return exibirRegistrosInativos ? emptyArrayOf<CiapSelectFieldModel>() : allValues.ciaps2
      },
      [metaFiltroHistorico.cids10.absolutePath()]: (
        exibirRegistrosInativos: boolean,
        allValues: HistoricoAtendimentoAdvancedFilterFormModel
      ) => {
        return exibirRegistrosInativos ? emptyArrayOf<CidSelectFieldModel>() : allValues.cids10
      },
    },
  }
}
